import {Container} from 'src/components/container/Container'
import styled from 'styled-components'

export const StyledAdminHostApprovalTask = styled.div`
    overflow-y: scroll;
`

export const StyledAdminHostApprovalTaskLoadingContainer = styled(Container)`
    display: flex;
    justify-content: center;
    align-items: center;
`
